var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('video',{attrs:{"width":"100%","controls":""}},[_c('source',{attrs:{"src":"http://www.cippe.com.cn/wx/video/1.mp4","type":"video/mp4"}}),_vm._v(" 您的浏览器不支持 video 标签。 ")])])
}]

export { render, staticRenderFns }